<template>
	<div id="services">
		<menu-component></menu-component>
		<div id="screen-container" class="screen-container">
			<default-header></default-header>
			<div class="panel-container">
				<collapsible-panel :panel="view.settingsPanel" @collapsed="onCollapsePanel" 
				v-if="view.settingsPanel.isVisible" :folded="view.settingsPanel.isFolded"
				:class="{'collapsible-panel-fullscren': view.settingsPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							id="settingsGrid"
							:grid="view.settingsPanel.gridConfiguration"
						></grid-component>
						<div class="button-container">
							<div class="button-container-align-left">
								<button class="refresh-button" @click="refreshGrid"> 
									<i class="fas fa-sync" :title="$t('update')"></i> 
								</button>
								<button class="grid-button button" @click="showExportModal('UNITY', 'settingsPanel')">
									<span><i class="fas fa-file-export"></i></span> {{$t('export_record')}}
								</button>
							</div>
							<div class="button-container-align-right">
								<button class="button gray-button" @click="exportToExcel(view.settingsPanel)">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.settingsPanel,'fullscreen')">
									<span v-show="!view.settingsPanel.fullscreen">
										<i class="fas fa-expand-arrows-alt"></i>
									</span>
									<span v-show="view.settingsPanel.fullscreen">
										<i class="fas fa-compress-arrows-alt"></i>
									</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>

				 <collapsible-panel :panel="view.monthSettingsPanel" @collapsed="onCollapseMonthPanel" 
				v-if="view.monthSettingsPanel.isVisible" :folded="view.monthSettingsPanel.isFolded"
				:class="{'collapsible-panel-fullscren': view.monthSettingsPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							id="settingsGrid"
							:grid="view.monthSettingsPanel.gridConfiguration"
						></grid-component>
						<div class="button-container">
							<div class="button-container-align-left">
								<button class="refresh-button" @click="refreshMonthGrid"> 
									<i class="fas fa-sync" :title="$t('update')"></i> 
								</button>
							</div>
							<div class="button-container-align-right">
								<button class="button gray-button" 
								@click="invertValue(view.monthSettingsPanel,'fullscreen')">
									<span v-show="!view.monthSettingsPanel.fullscreen">
										<i class="fas fa-expand-arrows-alt"></i>
									</span>
									<span v-show="view.monthSettingsPanel.fullscreen">
										<i class="fas fa-compress-arrows-alt"></i>
									</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>

				 <collapsible-panel :panel="view.portioningSetPanel"
				 	
					:collapsed.sync="view.portioningSetPanel.isFolded"
					v-if="view.portioningSetPanel.isVisible"
					:class="{'collapsible-panel-fullscren': view.portioningSetPanel.fullscreen}"
				 >
					<grid-component :grid="view.portioningSetPanel.gridConfiguration" 
					:hasCheckedRows.sync="view.portioningSetPanel.hasCheckedRows"
					:isAddingNewRow.sync="view.portioningSetPanel.isAddingNewRow"/>
					<div class="button-container">
						<div class="button-container-align-left">
							<button class="grid-button button" @click="addNewRowToPortioningSetGrid"> 
								<i class="fas fa-plus"></i> {{$t('new')}} 
							</button>
							<button class="grid-button button" @click="removePortioningSetNewRow"
								v-if="view.portioningSetPanel.isAddingNewRow"> 
								<i class="fas fa-times"></i> {{$t('cancel')}} 
							</button>
							<button class="grid-button button" @click="removePortioningSet"
								v-if="view.portioningSetPanel.hasCheckedRows && 
									!view.portioningSetPanel.isAddingNewRow"> 
								<span><i class="fas fa-trash"></i></span> {{$t('delete')}} 
							</button>
						</div>
						<div class="button-container-align-right">
								<button class="button gray-button" @click="exportToExcel(view.portioningSetPanel)">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.portioningSetPanel,'fullscreen')">
									<span v-show="!view.portioningSetPanel.fullscreen">
										<i class="fas fa-expand-arrows-alt"></i>
									</span>
									<span v-show="view.portioningSetPanel.fullscreen">
										<i class="fas fa-compress-arrows-alt"></i>
									</span>
								</button>
							</div>
					</div>
				 </collapsible-panel>
				 
				 <collapsible-panel :panel="view.daysOutRutSetPanel"
					:collapsed.sync="view.daysOutRutSetPanel.isFolded"
					v-if="view.daysOutRutSetPanel.isVisible"
					:class="{'collapsible-panel-fullscren': view.daysOutRutSetPanel.fullscreen}"
				 >
				 	<grid-component :grid="view.daysOutRutSetPanel.gridConfiguration"
					 	:hasCheckedRows.sync="view.daysOutRutSetPanel.hasCheckedRows"
						:isAddingNewRow.sync="view.daysOutRutSetPanel.isAddingNewRow"/>
					<div class="button-container">
						<div class="button-container-align-left">
							<button class="grid-button button" @click="addNewRowToDaysOutRutSetGrid"> 
								<i class="fas fa-plus"></i> {{$t('new')}} 
							</button>
							<button class="grid-button button" @click="removeDaysOutRutSetNewRow"
								v-if="view.daysOutRutSetPanel.isAddingNewRow"> 
								<i class="fas fa-times"></i> {{$t('cancel')}}  
							</button>
							<button class="grid-button button" @click="removeDaysOutRutSet"
								v-if="view.daysOutRutSetPanel.hasCheckedRows && 
									!view.daysOutRutSetPanel.isAddingNewRow"> 
								<span><i class="fas fa-trash"></i></span> {{$t('delete')}} 
							</button>
							<button class="grid-button button" @click="showExportModal('UNITY', 'daysOutRutSetPanel')"
								v-if="view.daysOutRutSetPanel.hasCheckedRows && 
									!view.daysOutRutSetPanel.isAddingNewRow"> 
								<span><i class="fas fa-file-export"></i></span> {{$t('export_record')}}
							</button>
						</div>
						<div class="button-container-align-right">
							<button class="button gray-button" @click="exportToExcel(view.daysOutRutSetPanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{$t('export')}} </span> 
							</button>
							<button class="button gray-button" @click="invertValue(view.daysOutRutSetPanel,'fullscreen')">
								<span v-show="!view.daysOutRutSetPanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.daysOutRutSetPanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
				 </collapsible-panel>

				 <collapsible-panel :panel="view.linkTypeDishesBetweenServicePanel"
					:collapsed.sync="view.linkTypeDishesBetweenServicePanel.isFolded"
					v-if="view.linkTypeDishesBetweenServicePanel.isVisible"
					:class="{'collapsible-panel-fullscren': view.linkTypeDishesBetweenServicePanel.fullscreen}"
				 >
				 	<grid-component :grid="view.linkTypeDishesBetweenServicePanel.gridConfiguration"
					 	:hasCheckedRows.sync="view.linkTypeDishesBetweenServicePanel.hasCheckedRows"
						:isAddingNewRow.sync="view.linkTypeDishesBetweenServicePanel.isAddingNewRow"/>
					<div class="button-container">
						<div class="button-container-align-left">
							<button class="grid-button button" @click="addNewRowToLinkTypeDishesSetGrid"> 
								<i class="fas fa-plus"></i> {{$t('new')}} 
							</button>
							<button class="grid-button button" @click="removeLinkTypeDishesSetNewRow"
								v-if="view.linkTypeDishesBetweenServicePanel.isAddingNewRow"> 
								<i class="fas fa-times"></i> {{$t('cancel')}}  
							</button>
							<button class="grid-button button" @click="removeLinkTypeDishes"
								v-if="view.linkTypeDishesBetweenServicePanel.hasCheckedRows && 
									!view.linkTypeDishesBetweenServicePanel.isAddingNewRow"> 
								<span><i class="fas fa-trash"></i></span> {{$t('delete')}} 
							</button>
						</div>
						<div class="button-container-align-right">
							<button class="button gray-button" @click="exportToExcel(view.linkTypeDishesBetweenServicePanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{$t('export')}} </span> 
							</button>
							<button class="button gray-button" @click="invertValue(view.linkTypeDishesBetweenServicePanel,'fullscreen')">
								<span v-show="!view.linkTypeDishesBetweenServicePanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.linkTypeDishesBetweenServicePanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
				 </collapsible-panel>
			</div>
		</div>
		<modal
			name="export-form-modal" 
			:height="'auto'" 
			:clickToClose="false"
		>
			<ExportForm 
				:modal="$modal"
				:name= "$t('export_record')"
				:modalStyle="view.exportDataModal._style"
				:showLoad="view.exportDataModal._showLoad"
				@saveExport="saveExport"
			/>
		</modal>
	</div>
</template>

<script>
import MenuComponent from '@/components/src/MenuComponent'
import DefaultHeader from '@/components/src/DefaultHeaderComponent'
import CollapsiblePanel from '@/components/src/CollapsiblePanelComponent'
import GridComponent from '@/components/src/GridComponent'
import ExcelBuilder from  '@/application/libs/excelBuilder'
import ExportForm from '@/components/src/ExportForm'
import Util from "@/application/libs/util"

import eventModule from '@/application/libs/eventModule'
import permissionManager from '@/application/libs/permissionManager'

import { t } from 'i18next';

import ServicesController from "../controllers/ServicesController";

export default {
	name: "Services",
	components:{
		MenuComponent,
		DefaultHeader,
		CollapsiblePanel,
		GridComponent,
		ExportForm
	},
	data() {
		return {
			view: {
				exportDataModal: {
					_showLoad: true
				},
				title: t('service'),
				settingsPanel:{
					title: t('service_configuration'),
					gridConfiguration: ServicesController.settingsGridConfiguration,
					fullscreen: false,
					isVisible: true,
					isFolded: false,
					info: t('info_service_configuration')+`\n`+ t('info_2_service_configuration') +`\n` + t('info_3_service_configuration') +`\n` + t('info_4_service_configuration') +`\n\n` + t('info_5_service_configuration') + `\n` + t('info_6_service_configuration') +`\n` + t('info_7_service_configuration') +`\n` + t('info_8_service_configuration') +`\n` + t('info_9_service_configuration') +`\n` + t('info_10_service_configuration')
				},
				monthSettingsPanel:{
					title: t('active_columns_by_month'),
					gridConfiguration: ServicesController.monthSettingsGridConfiguration,
					fullscreen: false,
					isVisible: true,
					isFolded: false,
					info: t('info_active_columns_by_month') +`\n` + t('info_2_active_columns_by_month')
				},
				portioningSetPanel:{
					title: t('portioning_set'),
					isFolded: true,
					gridConfiguration: ServicesController.portioningSetGridConfiguration,
					fullscreen: false,
					isAddingNewRow: false,
					hasCheckedRows: false,
					isVisible: true,
					info: t('info_portioning_set') +`\n` + t('info_2_portioning_set') +`\n` + t('info_3_portioning_set') +`\n` + t('info_4_portioning_set')
				},
				daysOutRutSetPanel:{
					title: t('non_routine_event_days'),
					isFolded: true,
					gridConfiguration: ServicesController.daysOutRutSetGridConfiguration,
					fullscreen: false,
					isAddingNewRow: false,
					hasCheckedRows: false,
					isVisible: true,
					info:`OI`
				},
				linkTypeDishesBetweenServicePanel:{
					title: t('link_dish_types_between_services'),
					isFolded: true,
					gridConfiguration: ServicesController.linkTypeDishesGridConfiguration,
					fullscreen: false,
					isAddingNewRow: false,
					hasCheckedRows: false,
					isVisible: true,
					info:`OI`
				}
			}
		};
	},
 	created(){
		 
		const permissions = permissionManager.getServicesViewPermissions();
		Object.keys(permissions).forEach(pName => this.view[pName].isVisible = permissions[pName]);
		permissions.settingsPanel && ServicesController.initServiceScreen(true);
		permissions.monthSettingsPanel && ServicesController.initMonthServiceScreen(true);
		eventModule.$on('updateBoData', this.initServiceScreen);
	},
	mounted() {
		document.title = `${this.view.title} - Cardápio Inteligente`;
	},
	beforeDestroy(){
		eventModule.$off('updateBoData', this.initServiceScreen);
	},
	methods:{
		refreshGrid: ()=>ServicesController.initServiceScreen(),
		refreshMonthGrid: ()=>ServicesController.initMonthServiceScreen(),
		onCollapsePanel(collapsed){
			if(!collapsed){
				ServicesController.initServiceScreen();
			}
			this.view.settingsPanel.isFolded = collapsed;
		},
		onCollapseMonthPanel(collapsed){
			if(!collapsed){
				ServicesController.initMonthServiceScreen();
			}
			this.view.monthSettingsPanel.isFolded = collapsed;
		},
		initServiceScreen: function(calledOnCreate = false){
			this.view.settingsPanel.isVisible && !this.view.settingsPanel.isFolded && ServicesController.initServiceScreen();
			this.view.monthSettingsPanel.isVisible && !this.view.monthSettingsPanel.isFolded && ServicesController.initMonthServiceScreen();
			this.view.portioningSetPanel.isVisible && !this.view.portioningSetPanel.isFolded && 
				calledOnCreate !== true && ServicesController.portioningSetGridConfiguration.reloadData();
			this.view.daysOutRutSetPanel.isVisible && !this.view.daysOutRutSetPanel.isFolded && 
				calledOnCreate !== true && ServicesController.daysOutRutSetGridConfiguration.reloadData();
			this.view.linkTypeDishesBetweenServicePanel.isVisible && !this.view.linkTypeDishesBetweenServicePanel.isFolded && 
				calledOnCreate !== true && ServicesController.linkTypeDishesGridConfiguration.reloadData();
		},
		invertValue: function(object, key){
			object[key] = !object[key];
		},
		addNewRowToPortioningSetGrid: function(){
			ServicesController.addNewRowToPortioningSetGrid();
		},
		addNewRowToDaysOutRutSetGrid: function(){
			ServicesController.addNewRowToDaysOutRutSetGrid();
		},
		addNewRowToLinkTypeDishesSetGrid: function(){
			ServicesController.addNewRowToLinkTypeDishesSetGrid();
		},
		removePortioningSetNewRow: function(){ //todo
			const {portioningSetPanel} = this.view;
			const rows = portioningSetPanel.gridConfiguration.getRowData();
			rows[0] && rows[0].__is_new_row && (rows[0].__removed = true) && rows.shift();
			portioningSetPanel.gridConfiguration.setRowData(rows);
			portioningSetPanel.gridConfiguration.enableSelection();
			portioningSetPanel.isAddingNewRow = false;
			portioningSetPanel.hasCheckedRows = false;
		},
		removeDaysOutRutSetNewRow: function(){
			const {daysOutRutSetPanel} = this.view;
			const rows = daysOutRutSetPanel.gridConfiguration.getRowData();
			rows[0] && rows[0].__is_new_row && (rows[0].__removed = true) && rows.shift();
			daysOutRutSetPanel.gridConfiguration.setRowData(rows);
			daysOutRutSetPanel.gridConfiguration.enableSelection();
			daysOutRutSetPanel.isAddingNewRow = false;
			daysOutRutSetPanel.hasCheckedRows = false;
		},
		removeLinkTypeDishesSetNewRow: function(){
			const {linkTypeDishesBetweenServicePanel} = this.view;
			const rows = linkTypeDishesBetweenServicePanel.gridConfiguration.getRowData();
			rows[0] && rows[0].__is_new_row && (rows[0].__removed = true) && rows.shift();
			linkTypeDishesBetweenServicePanel.gridConfiguration.setRowData(rows);
			linkTypeDishesBetweenServicePanel.gridConfiguration.enableSelection();
			linkTypeDishesBetweenServicePanel.isAddingNewRow = false;
			linkTypeDishesBetweenServicePanel.hasCheckedRows = false;
		},
		removePortioningSet: function() {
			ServicesController.removePortioningSetRows();
		},
		removeDaysOutRutSet: function() {
			ServicesController.removeDaysOutRutSetRows();
		},
		removeLinkTypeDishes: function() {
			ServicesController.removeLinkTypeDishesSetRows();
		},
		exportToExcel: function(view){
			let fixedData = null;
			if(view.title == t('service_configuration')) {
				fixedData = Util.getVisibleDataFromGrid(view.gridConfiguration);
				fixedData.forEach((linha) => {
					Object.entries(linha).forEach((dado) => {
						if(dado[1] == `<i class="fas fa-check" style="text-align:'center'"/>`) {
							linha[dado[0]] = '✓'
						}
					})
				})
			}
			ExcelBuilder.fromJson(
				fixedData || Util.getVisibleDataFromGrid(view.gridConfiguration),
				Util.getGridColDefsToColDetails(view.gridConfiguration.columnDefs),
				view.title,
				Util.getExcelHeaderFromFilter(),
			);
		},
		showExportModal: function(modalStyle, caller) {
			this.view.exportDataModal._style = modalStyle;
			this.view.exportDataModal._showLoad = true;
			this.view.exportDataModal._caller = caller;
			this.$modal.show("export-form-modal");
			this.$forceUpdate();
		},
		saveExport: function(view) {
			this.view.exportDataModal._showLoad = false;
			this.view.exportDataModal._mode = view.exportData.mode;
			this.$forceUpdate();
			const filiServ = this.getFiliServ(view.exportData);
			if(this.view.exportDataModal._caller == 'daysOutRutSetPanel') {
				const checkedDays = this.getCheckedDays();
				ServicesController.saveExportDayOutOfRut([filiServ, checkedDays], this.view.exportDataModal, this.$modal);
			} else if (this.view.exportDataModal._caller == 'settingsPanel') {
				ServicesController.saveExportConfCard(filiServ, 'CONFCARD', [1], view.exportData.mode, {MODE: null, GROUPARR: null}).then((response) => {
					if(response.data.length > 0) {
						this.showMessageError(response.data);
					} else {
						this.view.exportDataModal._showLoad = true;
						Util.showSuccessNotification({ title: t('successful_export')});
						this.$modal.hide('export-form-modal');
					}
				});
			}
		},
		getFiliServ: function(data) {
			const filiServ = [];
			if(data.checkedService) {
				data.services.forEach((service) => { filiServ.push(service.CDLISTA) });
			} else {
				data.selectedService.forEach((service) => { filiServ.push(service.CDLISTA) });
			}
			return filiServ;
		},
		getCheckedDays: function() {
			const checked = [];
			const nodes = this.view.daysOutRutSetPanel.gridConfiguration.gridControl.getSelectedRows();
			nodes.forEach((row) => checked.push(row.NRCARDIAEVENTO));
			return checked;
		},
		buildMessage:function(data) {
			let message = [];
			data.forEach((error) => {
				let msg = error.DSERRO;
				msg = msg.replace('_MSGSTA_CONSISTE_GRUPOPRATO', '');
				msg = msg.replace("_MSGEND_", "");
				msg = msg.split("$$");
				message.push({ CDFILIAL: msg[1], CDSERVFILI: msg[2], CDGRUPRAT: msg[3] });
			});
			return message;
		},
		showMessageError:function(data) {
			this.view.exportDataModal._showLoad = true;
            const messages = this.buildMessage(data);
            this.$modal.show({
                template:`
                    <div class="validity-form-root" style="margin: 0; padding: 25px; width: calc(100% - 50px);"> 
                        <h3 class="title"> Erros na Exportação: Grupos de Pratos não associados ao serviço destino </h3>
                        <div style="max-height: 500px; overflow: auto; padding: 30px 0; width: 100%;">
                            <span v-for="message in messages" style="display:block; margin: 10px;"> Unidade: {{message.CDFILIAL}} Serviço: {{message.CDSERVFILI}} 
                            Grupo de Prato: {{message.CDGRUPRAT}}</span>
                        </div>
                        <div>
                            <button class="button" style="margin: 15px auto; display: block; min-width: 200px;" @click="close"> OK </button>
                        </div>
                    </div>
                `,
                props: ['messages'],
                methods:{
                    close(){this.$emit('close');}
                }
            }, {messages}, {
                height:'auto',
                width:'69%',
            });
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import (reference) url("../../assets/variables.less");

#services{
	height: 100vh;
	width: 100vw;
	display: flex;

	.v--modal-overlay{
		z-index: 21;
	}

	#collapsible-panel.collapsible-panel-fullscren{
		position: fixed;
		top: 48px;
    	left: 100px;
		z-index: 2;
		background-color: white;
		height: calc(100vh - 69px);
    	width: calc(100vw - 125px);
		padding: 20px 15px;
		border-radius: 0;
		padding-top: 0px;
		margin:0;

		#panel-header{
			.up-arrow, .down-arrow{
				display: none;
			}
		}

		#panel-content{
			.ag-grid-instance{
				height: calc(100vh - 126px);
			}
		}
	}

	.button-container-align-left, .button-container-align-right{
		display: inline-block;
		flex: 1;
	}

	.button-container{
		display: flex;
    	justify-content: space-between;
	}

	.button-container-align-right{
		text-align: right;
		&.full-width{
			width: 100%;
		}
	}

	.xx-panel-button-container{
		display: flex;
	}

	.gray-button{
		.grid-button;
		box-shadow: none;
		background-color: #dedede;
		color: #383838;
		&:hover{
			background-color: gray;
			color:white;
		}
	}

	.screen-container{
		height: 100vh;
		overflow-y: scroll;
		flex: 1;
	}

	.grid-button{
		margin-top: 3px;
		font-size: .9rem;
		padding: 6px 13px;
	}

	.refresh-button{
		background-color: #bdc3c7;
		border: 0;
		height: 28px;
		width: 40px;
		margin-top: 5px;
		border-radius: 5px;
		color: #383838;
		.clicavel;
		transition: background-color .5s ease, color .5s ease;

		&:hover{
			background-color: gray;
			color:white;
		}
	}
}

.ag-header-cell-label{
	font-weight: 700;
}
</style>
